import React, { Component } from 'react'
import styled from 'styled-components'
import Editor from '../TextEditor/Editor'
import ReadOnlyEditor from '../TextEditor/ReadOnlyEditor'
import Reply from './Reply'
import NotesUtil from '../../helpers/NotesUtil'

const Container = styled.div`
  min-height: 100px;
  border: ${props => (props.draft ? 'none' : '0.5px solid #DBDBDC')};
  background-color: ${props => (props.draft ? '#F2F2F2' : 'white')};
  box-shadow: 0 2px 4px 0 #DBDBDC;
  margin-top: 15px;
`
const SenderInformation = styled.div`
  display: inline-flex;
`
const StatusContainer = styled.div`
  display: inline-flex;
  color: ${props => (props.approved ? '#17B853' : '#6A6A6A')};
  font-family: "Open Sans";
  font-size: 14px;
  line-height: 19px;
`
const AcronymContainer = styled.div`
  display: flex;
  margin-right: 10px;
`
const Acronym = styled.div`
  display: flex;
  height: 23px;
  width: 32px;
  color: #FFFFFF;
  font-family: "Open Sans";
  font-size: 14px;
  font-weight: 600;
  line-height: 19px;
  align-self: center;
  justify-content: center;
`
const TitleContainer = styled.div`
  display: flex;
  min-height: 19px;
  color: #6A6A6A;
  font-family: "Open Sans";
  font-size: 14px;
  line-height: 19px;
  margin-top: 5px;
`
const Header = styled.div`
  padding: 12px 15px;
  min-height: 44px;
  width: 100%;
  color: #56565A;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  line-height: 19px;
  display: flex;
  box-sizing: border-box;
  justify-content: space-between;
`
const DraftHeader = styled(Header)`
  display: flex;
  justify-content: space-between;
`
const DraftTitleContainer = styled.div`
  display: inline-flex;
`
const AccessText = styled.div`
  display: inline-flex;
`
const ContentContainer = styled.div`
  margin-left: 70px;
  min-height: 19px;
  margin-right: 15px;
  font-size: 14px;
`
const DraftContainer = styled(ContentContainer)`
  margin-left: 0;
`
const Content = styled.div`
  display: inline-flex;
  min-height: 38px;
  color: #56565A;
  font-family: "Open Sans";
  font-size: 14px;
  line-height: 19px;
`
const DraftContent = styled(Content)`
  margin-top: 10px;
  display: inline-flex;
  font-style: italic;
`
const Oval = styled.div`
  height: 32px;
  width: 32px;
  background-color: ${props => (props.bankUser ? '#27749B' : '#994F00')};
  display: inline-flex;
  margin-left: 10px;
  border-radius: 16px;
`
const Line = styled.div`
  box-sizing: border-box;
  height: 1px;
  border: 1px solid #DBDBDC;
  margin-right: 15px;
  margin-left: ${props => (!props.draft ? '70px' : '15px')}
`
const OptionsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-right: 20px;
  margin-bottom: 10px;
`
const Button = styled.div`
  display: flex;
  height: 19px;
  color: #3399CC;
  font-family: "Open Sans";
  font-size: 14px;
  line-height: 19px;
  cursor: pointer;
  margin-right: 3px;
  margin-left: 3px;
`
const DraftText = styled.div`
  display: flex;
  color: #AE6971;
  padding-right: 5px;
`
const DraftContentWrapper = styled.div`
  margin-left: 15px;
  display: flex;
  justify-content: space-between;
`

const HoverButtonContainer = styled.div`
  display: inline-flex;
  margin-right: 15px;
  align-self: center;
`
const IconContainer = styled.div`
  font-size: 15px;
  display: inline-flex;
  margin-left: 15px;
  height: 24px;
  width: 24px;
  border-radius: 12px;
  background-color: #3399CC;
`
const Icon = styled.i`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  color: white;
  padding: 5px;
  margin-left: 1px;
  cursor: pointer;
`
const ShowRepliesContainer = styled.div`
  cursor: pointer;
`

const ShowReplies = styled.div`
  display: inline-flex;
  height: 19px;
  color: #56565A;
  font-family: "Open Sans";
  font-size: 14px;
  line-height: 19px;
  margin: 15px 0px 15px 70px;
`
const ArrowDown = styled(Icon)`
  color: #56565A;
`

export default class Question extends Component {
  constructor(props) {
    super(props)
    const isContentZero = this.isContentZero(props.data.content)
    this.state = {
      data: props.data,
      editorState:  isContentZero ? 'open' : 'closed',
      editorContent: props.data.content,
      isEditDraft: false,
      published:  isContentZero ? false : true,
      optionClicked: '',
      questionStatus: isContentZero ? 'new_question' : '',
      isHovered: false,
      showRepliesClicked: false,
      document: props.document,
    }
  }

  isContentZero = content => {
    return content.length === 0
  }

  componentWillReceiveProps({ data }) {
    if (data !== null) {
      this.setState({
        ...this.state,
        data,
        questionStatus: this.isContentZero(data.content) ? 'new_question' : '',
      })
    }
  }

  renderHeader = data => {
    const { createdAt, state } = data
    const { name, bankUser } = data.administrator
    const showStatus = ['pending_approval', 'approved'].includes(state)
    return (
      <Header>
        <SenderInformation>
          <AcronymContainer>
            <Oval bankUser={bankUser}><Acronym>
              {NotesUtil.getAdminAcronym({ name })}
            </Acronym></Oval>
          </AcronymContainer>
          <TitleContainer>
            {name} {createdAt}
          </TitleContainer>
        </SenderInformation>
        {showStatus &&
          <StatusContainer approved={state === 'approved'}>
            {state === 'approved' ? 'Approved' : 'Pending approval'}
          </StatusContainer>
        }
      </Header>
    )
  }

  renderPublishedContent = (data) => {
    const { document } = data
    return (
      <ContentContainer key={data.rid}>
        <ReadOnlyEditor
          md={data.content}
          files={document ? document.fileUrls: [] }
        />
      </ContentContainer>
    )
  }

  renderShowRepliesOption = () => {
    const { state } = this.state.data
    const { showRepliesClicked } = this.state
    const publishedReplies = this.repliesNoDraft.length
    if (state === 'approved'){
      return (
        <ShowRepliesContainer onClick={this.onShowRepliesClicked}>
          <Line draft={false} />
          <ShowReplies>
            {showRepliesClicked ? 'Hide'  : 'Show'} {publishedReplies} replies
          </ShowReplies>
           <ArrowDown className={`fa fa-angle-${showRepliesClicked ? 'up' : 'down'}`} />
        </ShowRepliesContainer>
      )
    }
  }

  get repliesNoDraft() {
    const { replies } = this.state.data
    return replies.filter(({ draft }) => !draft)
  }

  getLastPublishedReply = () => {
    return this.repliesNoDraft.pop();
  }

  renderReplies = () => {
    const { replies, state } = this.state.data
    const { editorState, optionClicked, showRepliesClicked } = this.state
    const showReplies = (editorState === 'closed' || optionClicked === 'reply') && (state !== 'approved' || showRepliesClicked)
    const lastReply = this.getLastPublishedReply()
    if (showReplies) {
      return (
        replies.map(reply => {
          return (
            <Reply
              key={`reply-${reply.rid}`}
              data={reply}
              replies={replies}
              optionClicked={optionClicked}
              isLastReply={lastReply !== undefined && reply.rid === lastReply.rid}
              approved={state === 'approved'}
              currentAdminId={this.props.currentAdminId}
              isBankUser={this.props.isBankUser}
              onReplyClick={this.onReplyClick}
              onSaveAsDraftClick={this.onReplySaveAsDraftClick}
              onPostClick={this.onReplyPostClick}
              onDeleteClick={this.onReplyDeleteClick}
              onMarkAsApprovedClick={this.onQuestionStatusChange}
              />
          )
        })
      )
    }
  }

  onShowRepliesClicked = () => {
    this.toggleState('showRepliesClicked')
  }

  onQuestionEditClick = () => {
    const { content, state } = this.state.data
    this.setState({
      ...this.state,
      editorState: 'open',
      editorContent: content,
      isEditDraft: true,
      published: state === 'published',
      optionClicked: 'edit',
      questionStatus: 'edit_question',
      isHovered: false,
    })
  }

  onReplyClick = () => {
    this.setState({
      ...this.state,
      editorState: 'open',
      editorContent: '',
      isEditDraft: false,
      published: false,
      optionClicked: 'reply',
      questionStatus: 'reply_question',
      isHovered: false,
    })
  }

  onQuestionDeleteClick = () => {
    const { onDeleteQuestion } = this.props
    const { rid } = this.state.data
    this.setState({ editorState: 'closed', })
    onDeleteQuestion(rid)
  }

  onQuestionStatusChange = () => {
    const { rid, content, files, deleteFiles, state } = this.state.data
    const { onUpdateExisting } = this.props
    const newStatus = `${state === 'approved' ? 'pending_' : ''}approve`
    this.setState({
      ...this.state,
      showRepliesClicked: false,
      data: {
        ...this.state.data,
        state: newStatus,
      }
    })
    onUpdateExisting({ rid: rid, state: newStatus,  editorContent: content, files: files, deleteFiles: deleteFiles })
  }

  showReplyButton = (adminId, replies) => {
    const { isBankUser } = this.props
    if (isBankUser) {
      const adminReplies = replies.filter(({ draft, administrator: { rid }}) => (draft && rid === adminId) || (!draft && rid === adminId))
      return adminReplies.length === 0
    } else {
      return replies.length === 0
    }
  }

  renderOptions = () => {
    const { currentAdminId } = this.props
    const { optionClicked } = this.state
    const { state, replies, administrator } = this.state.data
    const showEdit = state !== 'approved' &&  currentAdminId === administrator.rid
    const showReply = this.showReplyButton(currentAdminId, replies)
    if (optionClicked !== 'reply') {
      return (
        <OptionsContainer>
          { showEdit && (
            <Button
              onClick={this.onQuestionEditClick}>
                Edit
            </Button>
          )}
          { showEdit && showReply && <span>|</span>}
          { showReply && (
            <Button
              onClick={this.onReplyClick}>
                Reply
            </Button>
          )}
        </OptionsContainer>
      )
    }
  }

  onCloseClick = () => {
    const { onCloseClick } = this.props
    const { data, optionClicked } = this.state
    if (optionClicked === ''){
      onCloseClick();
    } else {
      data.replies.filter(({ rid })=> rid !== null)
    }
    this.setState({ editorState: 'closed', isEditDraft: false, optionClicked: '', isHovered: true })
  }

  onSaveAsDraftClick = (editorTitle, editorContent, files, deleteFiles) => {
    const { optionClicked, data } = this.state
    const { rid } = data
    const { onSaveNew, onUpdateExisting , onNewReply} = this.props
    if (optionClicked !== 'reply') {
      if (rid === null) {
        onSaveNew({ state: 'draft', editorContent, files })
      } else {
        onUpdateExisting({ rid: rid, state: 'draft', editorContent, files, deleteFiles })
      }
    } else if (optionClicked === 'reply') {
        onNewReply({ rid: rid, draft: true, editorContent, files })
    }

    this.setState({ editorState: 'closed', isEditDraft: false, optionClicked: '' });
  }

  onPostClick = (editorTitle, editorContent, files, deleteFiles) => {
    const { optionClicked, data } = this.state
    const { rid } = data
    const { onSaveNew, onUpdateExisting, onNewReply} = this.props
    if (optionClicked !== 'reply'){
      if (rid === null) {
        onSaveNew({ state: 'publish', editorContent, files })
      } else {
        onUpdateExisting({ rid: rid, state: 'publish', editorContent, files, deleteFiles })
      }
    } else {
      onNewReply({ rid: rid, draft: false, editorContent, files })
    }

    this.setState({ editorState: 'closed', isEditDraft: false, optionClicked: '' })
  }

  onReplySaveAsDraftClick = ({ replyId, draft, editorContent, files, deleteFiles }) => {
    const { onUpdateReply } = this.props
    const { rid } = this.state.data
    onUpdateReply({ rid: replyId, draft, editorContent, files, deleteFiles })
  }

  onReplyPostClick = ({ replyId, draft, editorContent, files, deleteFiles }) => {
    const { onUpdateReply } = this.props
    const { rid } = this.state.data
    onUpdateReply({ questionId: rid, rid: replyId, draft, editorContent, files, deleteFiles })
  }

  onReplyDeleteClick = ({ replyId }) => {
    const { onDeleteReply } = this.props
    onDeleteReply({ replyId })
  }

  renderHoverButtons = () => {
    const { isHovered } = this.state
    if (isHovered) {
      return (
        <HoverButtonContainer>
          <IconContainer>
            <Icon className="fa fa-pencil" onClick={this.onQuestionEditClick} />
          </IconContainer>
          <IconContainer>
            <Icon className="fa fa-trash" onClick={this.onQuestionDeleteClick} />
          </IconContainer>
        </HoverButtonContainer>
      )
    }
  }

  toggleState = state => {
    this.setState({
      [state]: !this.state[state]
    })
  }

  onMouseEnter = () => {
    this.toggleState('isHovered')
  }

  onMouseLeave = () => {
    this.toggleState('isHovered')
  }

  renderDraft = (data) => {
    const draftText = '[Draft]'
    const title = 'Question'
    const accessText = NotesUtil.getAccessText(this.props.isBankUser)
    return (
      <DraftContainer key={`draft-${data.rid}`}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}>
        <DraftHeader >
          <DraftTitleContainer>
            {title}
          </DraftTitleContainer>
        <AccessText>
          {accessText}
        </AccessText>
        </DraftHeader>
        <Line draft={data.state === 'draft'} />
        <DraftContentWrapper>
          <DraftContent key={`draft-content-${data.rid}`}>
            <DraftText>
              {draftText}
            </DraftText>
            {data.content}
          </DraftContent>
          {this.renderHoverButtons()}
        </DraftContentWrapper>
      </DraftContainer>
    )
  }

  renderPublishedQuestion = data => {
    const { questionStatus, optionClicked } = this.state
    const { state, replies } = data
    if (questionStatus !== 'new_question' && optionClicked !== 'edit') {
      return (
        <div>
          {this.renderHeader(data)}
          {this.renderPublishedContent(data)}
          {this.renderOptions()}
          {state === 'approved' && this.renderShowRepliesOption()}
          {replies.length > 0 && this.renderReplies()}
        </div>
      )
    }
  }

  get isDraft() {
    const { data: { state } } = this.state
    return state === 'draft'
  }

  get isValidDocument() {
    const { data: { document }, optionClicked } = this.state
    return optionClicked !== 'reply' && document
  }

  get files() {
    const { data: { document } } = this.state
    return this.isValidDocument ? document.files : []
  }

  get fileUrls() {
    const { data: { document } } = this.state
    return this.isValidDocument ? document.fileUrls : []
  }

  renderEditor = () => {
    const { editorContent, isEditDraft, published, questionStatus } = this.state
    const isNewQuestion = questionStatus === 'new_question'
    return (
      <Editor
        isNewQuestion={isNewQuestion}
        questionStatus={questionStatus}
        published={published}
        predefined={!this.isDraft || !isNewQuestion}
        fileUUIDs={this.files}
        fileUrls={this.fileUrls}
        isBankUser={this.props.isBankUser}
        onPostClick={this.onPostClick}
        onSaveAsDraftClick={this.onSaveAsDraftClick}
        onCloseClick={this.onCloseClick}
        onDeleteClick={this.onQuestionDeleteClick}
        isEditDraft={isEditDraft}
        content={editorContent} />
    )
  }

  render() {
    const { data, editorState, optionClicked } = this.state
    const isEditWorkflow = optionClicked === 'edit'
    return (
      <Container draft={this.isDraft}>
        {editorState === 'closed' && !isEditWorkflow &&
          this.isDraft && this.renderDraft(data)
        }
        {!this.isDraft && this.renderPublishedQuestion(data)}
        {editorState === 'open' && this.renderEditor()}
      </Container>
    )
  }
}
